"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FavoriteFriendsIndexes = void 0;
exports.FavoriteFriendsIndexes = [0, 1, 2];
// export const FavoriteFriendsIndexes = [] as number[];
